import React from "react";
import { graphql } from "gatsby";

export default function Heading({ data }) {
  const Htag = data.useH1 ? "h1" : "h2"

  return (
    <section className="mx-auto max-w-3xl text-center z-10 relative mt-4 md:mt-20 mb-4 md:mb-10 hds-text-color px-6">
      {data.heading && (
        <Htag className="hds-title__medium mb-xs md:mb-sm font-bold font-heading bold-color capitalize">{data.heading}</Htag>
      )}

      {data.subheading && (
        <p className="md:px-xs">{data.subheading}</p>
      )}    
    </section>
  );
}

export const headingQuery = graphql`
  fragment HeadingComponent on DatoCmsHeading {
    internal {
      type
    }
    heading
    useH1
    subheading
  }
`;
